import { render, staticRenderFns } from "./alter-ego-de-palmer.vue?vue&type=template&id=2adac3c7&scoped=true"
import script from "./alter-ego-de-palmer.vue?vue&type=script&lang=js"
export * from "./alter-ego-de-palmer.vue?vue&type=script&lang=js"
import style0 from "./alter-ego-de-palmer.vue?vue&type=style&index=0&id=2adac3c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adac3c7",
  null
  
)

export default component.exports